import { Pipe, PipeTransform, inject } from '@angular/core';
import { PermissionsDTO } from '@api';
import { TokenService } from './token.service';

@Pipe({
  name: 'hasPermission',
  standalone: false,
})
export class PermissionPipe implements PipeTransform {
  private tokenService = inject(TokenService);

  transform(permission: PermissionsDTO): boolean {
    return this.tokenService.hasPermission(permission);
  }
}
